export default {
  state: {
    config: {}, // 渠道配置信息
    isCanSelectSkill: false, // 判断是否可以选择技能组
    leaveTitle: '', // 留言标题
    leaveType: 2, // 留言类型
    leaveMesageConfig: {
      isOpen: false, // 留言是否开启
      isShowButton: false, // 留言按钮
      isShowTitle: false // 留言标题
    },
    feedBackConfig: {
      isOpen: false, // 满意度是否开启
      endEvaluate: false, // 会话结束主动邀评
      resultRemind: false, // 评价结果信息提醒
      evaluateInvite: false, // 评价邀请语
      evaluateThank: false, // 评价感谢语
      criterion: false, // 评价标准设置
      dissatisfiedCause: false, // 不满意原因设置
      opinionFeedback: false // 意见反馈框
    } // 反馈配置
  },
  getters: {
    fontSize (state) {
      return state.config.fontSize || '14'
    }
  },
  mutations: {
    set_LeaveTitle (state, msg) { // 设置留言标题
      state.leaveTitle = msg
    },
    set_config (state, msg) {
      state.config = {
        ...state.config,
        ...msg
      }
    },
    set_leaveType (state, msg) {
      state.leaveType = msg
    },
    set_feedBackConfig (state, msg) {
      state.feedBackConfig = msg
    },
    set_leaveMesageConfig (state, msg) {
      state.leaveMesageConfig = msg
    }
  },
  actions: {

  }
}
